import React, { ReactNode } from 'react';
import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

interface Props extends CheckboxProps {
  label?: ReactNode;
  dataTestId?: string;
}

export const FormCheckbox = ({ label, dataTestId, ...checkboxProps }: Props) => {
  const classes = useStyles();

  return (
    <FormControlLabel
      label={label}
      control={
        <Checkbox
          size="small"
          disableRipple
          color="primary"
          className={classes.checkbox}
          {...checkboxProps}
          inputProps={
            {
              ...checkboxProps.inputProps,
              ...(dataTestId ? { data_test_id: dataTestId } : {}),
            } as any
          }
        />
      }
    />
  );
};

const useStyles = makeStyles({
  checkbox: {
    padding: '0 9px',

    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-checked:hover': {
      backgroundColor: 'transparent',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'transparent',
    },
  },
});
